module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-60x60.ba3ced141c7d67f7b11d3df2793c8575.png";